import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleDownMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronTriangleDownMedium"><Path d="M12 17.166L5.14062 9H18.8594L12 17.166Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleDownMedium;
